import { get } from "api/axiosApi";
import { env } from "utils/env";

const url = env.REACT_APP_LEASING_API_URL;

const getPropertyDetails = propertyId => {
  return get(`${url}/leasingoffers/asset/property/${propertyId}/detail`);
};

const exp = {
  getPropertyDetails
};
export default exp;
